import config from "./config";
import apiService from "./apiService";
import { ApplicationName } from "../helpers/constant";
export default {
  async getAuthInformation(key) {
    let authApiUrl = `${config.authApiUrl}/${key}`;
    return apiService.get(authApiUrl);
  },
  async getAuthCodeWithChallange(code_challenge) {
    let data = {};
    let options = { withCredentials: true };
    let url = `${config.getAuthCodeUrl}?app_id=${ApplicationName}&code_challenge=${code_challenge}`;
    return apiService.post(url, data, options);
  },
  getRefreshToken(refreshToken) {
    let data = {};
    let options = { withCredentials: true };
    let url = `${config.tokenVerifierUrl}?app_id=${ApplicationName}&grant_type=refresh_token&refresh_token=${refreshToken}`;
    return apiService.post(url, data, options);
  },
  getTokenWithVerifier(code, claims, code_verfier) {
    let options = { withCredentials: true };
    let url = `${config.tokenVerifierUrl}?app_id=${ApplicationName}&grant_type=authorization_code&code=${code}&code_verifier=${code_verfier}`;
    return apiService.post(url, claims, options);
  },
};
